/**
 * @file splashScreen.component.tsx
 * @path apps/website/src/components/common/splashScreen.component.tsx
 * @description
 */

import { branding } from "@/config";
import { useEffect, useState } from "react";

interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen = ({ onComplete }: SplashScreenProps) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Wait for page to fully load
    const handleLoad = () => {
      // Small delay to ensure everything is ready
      setTimeout(() => {
        setIsVisible(false);
        // Wait for fade animation to complete before calling onComplete
        setTimeout(onComplete, 500);
      }, 1000);
    };

    // If already loaded
    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    }
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-50 bg-background flex items-center justify-center transition-opacity duration-500 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="animate-pulse">
        <img
          src={branding.logoDark}
          alt="Sir Bastians Shuttle Service"
          width={150}
          height="auto"
          className="max-w-[200px] w-auto h-auto"
        />
      </div>
    </div>
  );
};

export default SplashScreen;
